export enum AddressesEndpoints {
  GET_SUGGESTIONS = '/suggest',
}

export interface IFullAddress {
  full_address: string;
  street_name: string;
  house_number: string;
  house_letter: string;
  postal_code: string;
  place: string;
  place_id?: string;
}

export interface IAddress {
  full_address: string;
  place_id?: string;
}

// ------------------- DTO --------------------

export interface IFullAddressSuggestionsDTO {
  query: string;
  limit?: number;
}

// ------------------- Responses --------------------

export type IFullAddressSuggestionsResponse = IFullAddress[];
